<label class="toggle">
    <input
        type="checkbox"
        [checked]="value"
        [ngModel]="value"
        (blur)="onTouched()"
        (change)="onChange(value)" />
    <div
        class="slider"
        [class.checked]="value"
        [class.unchecked]="!value">
        <span class="icon">
            <fa-icon
                class="icon"
                size="sm"
                [icon]="value ? ['fas', 'check'] : ['fas', 'xmark']" />
        </span>
    </div>
</label>
